import * as Sentry from '@sentry/browser';
import logException from '@util/js-error';
import globalActions from '@actions';

export default ({ dispatch }) =>
  next =>
  action => {
    if (
      action.type !== globalActions.ADD_FETCH.type &&
      action.type !== globalActions.REMOVE_FETCH.type
    ) {
      Sentry.addBreadcrumb({
        message: action.type,
        category: 'action',
        level: 'info'
      });
    }

    try {
      return next(action);
    } catch (ex) {
      const sentryId = logException(ex, { action });
      ex.data = {
        sentryId,
        exceptionText: ex.toString(),
        dsn: sentryId
          ? 'https://eb20356129ea49048db0994bd268f15e@sentry.io/205101'
          : undefined
      };
      return dispatch(globalActions.FETCH_RESOURCE_FAIL({ error: ex }));
    }
  };
